import Base from './ProductCategoryBase'
import { PItem } from './Item'

// ============================================================================
// class定義
// ============================================================================
export class Product extends Base {
  public productId = 0
  public representCategoryId = 0
  public productCategory: PItem[] = []
  public productCompany: PItem = { id: 0, name: '' }
  public description = ''
  public tabs = []
  public tabLabels: { [key: string]: string } = {}
  public releaseDate = 0
  public discontinued = false
  public newFlg = false
  public standardList: PItem[] = []
  public recommended = false
}

export class Category extends Base {
  public representParentId = 0
  public parent: number[] = []
  public depth = 0
  public children: Category[] = []
  public products: Product[] = []
}

// ============================================================================
// function定義
// ============================================================================

/**
 * 製品の発売日時が1年以内かどうかチェックする
 */
declare let nowtime: string // now_time.cgiに定義している変数
export const setupNew = async (obj: Product): Promise<void> => {
  const now = new Date(nowtime)

  // 経過時間をミリ秒で取得
  // 単位を合わせるために1000倍している
  const ms = now.getTime() - obj.releaseDate * 1000

  // ミリ秒を日付に変換(端数切捨て)
  const dayDiff = Math.floor(ms / (1000 * 3600 * 24))

  // 経過日数が1年以上ならfalse, 1年未満なら true
  if (dayDiff >= 365) {
    obj.newFlg = false
  } else {
    obj.newFlg = true
  }
}
